import { createIcon } from '../createIcon';

export const HeartBrokenIconConfig = {
  name: 'HeartBrokenIcon',
  height: 512,
  width: 512,
  svgPath: 'M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const HeartBrokenIcon = createIcon(HeartBrokenIconConfig);

export default HeartBrokenIcon;